import React from 'react'
import {Tooltip, Typography} from '@material-ui/core';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import clsx from 'clsx';
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import {makeStyles} from "@material-ui/styles";
import ErrorIcon from '@material-ui/icons/Error';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import BoldTypography from "components/BoldTypography";

const useStyle = makeStyles(theme => ({
    root: {
        '&>*:nth-child(2)': {
            flexGrow: 1,
        }
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    marginRight: {
        marginRight: theme.spacing()
    }

}))

function TemplateMembersElementTitle(
    {
        groupId,
        index,
        member,
        open,
        onOpen,
        editable,
        coordinatorView,
        validationSection,
    }) {

    const classes = useStyle();


    return (
        <GridBlock
            alignItems='center'
            wrap='nowrap'
            className={classes.root}
        >
            {!coordinatorView ?
                <Typography
                    variant='body1'
                    className={classes.marginRight}
                >
                    {index + 1}.
                </Typography>
                : <Typography> </Typography>
            }

            <BoldTypography
                variant='body1'
                className={clsx({[classes.cursorPointer]: editable})}
                onClick={editable ? onOpen : undefined}
            >
                {member.memberName}
            </BoldTypography>
            {editable && !coordinatorView && !member.allFormsAccepted &&
                <Tooltip title={Tr('purchase_groups_form_waiting_for_accept_exist')} placement="top">
                    <ErrorIcon className={classes.cursorPointer} onClick={onOpen} color='error'/>
                </Tooltip>
            }
            {editable && !coordinatorView && member.askForEditPending &&
                <Tooltip title={Tr('purchase_groups_form_ask_edit_exist')} placement="top">
                    <HourglassFullIcon className={classes.cursorPointer} onClick={onOpen} color='error'/>
                </Tooltip>
            }
            {editable && !coordinatorView && <WorkableIconExpandButton
                color='primary'
                onClick={onOpen}
                expanded={open}
                disabled={!editable}
            />}
        </GridBlock>
    )
}

TemplateMembersElementTitle.propTypes = {}

export default TemplateMembersElementTitle;